import React from 'react';
import { meetings } from '../data/content';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const numberColors = ['text-brand', 'text-coral-ink', 'text-violet-ink'];

/** The 10 complete programs with their target skill and start week */
export function MeetingsList() {
  return <section id="programs" aria-labelledby="programs-title" className="scroll-mt-4 bg-mist py-12 md:py-20" data-id="element-179" data-mp="7kexh91poio7">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-180" data-mp="3fzf9yuogxiqt">
        <SectionHeading id="programs-title" eyebrow={meetings.eyebrow} title={meetings.title} sub={meetings.sub} data-id="element-181" data-mp="3bxtq2pdio474" />

        <ol className="mx-auto mt-8 grid max-w-[980px] gap-3 md:mt-12 md:grid-cols-2 md:gap-4" data-id="element-182" data-mp="3py4j9z2atuvg">
          {meetings.items.map((m, i) => <li key={m.n} className="flex gap-3 rounded-xl border border-mist-line bg-white p-5" data-id="element-183" data-mp="3l0343p7zufp9" data-mpi={i}>
              <span className={`w-12 shrink-0 font-display text-[1.9rem] font-black leading-none ${numberColors[i % numberColors.length]}`} data-id="element-184" data-mp="158ynx76w95iw">{m.n}</span>
              <div className="min-w-0" data-id="element-185" data-mp="17tyhldadnvd3">
                <p className="text-[11px] font-bold tracking-[0.1em] text-ink/55" data-id="element-186" data-mp="17v9hv34m6kzg">
                  {meetings.weekLabel} {m.week}
                </p>
                <h3 className="mt-0.5 font-display text-[16px] font-extrabold uppercase leading-snug tracking-tight text-ink" data-id="element-187" data-mp="1hr32l9shlksb">{m.title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-ink/75" data-id="element-188" data-mp="1mpo4ddne0civ">{m.goal}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 flex max-w-[460px] justify-center" data-id="element-189" data-mp="u18qwvjwm29n">
          <CtaButton label={meetings.cta} microcopy={meetings.ctaMicrocopy} align="center" data-id="element-190" data-mp="tzfm7lsups4a" />
        </div>
      </div>
    </section>;
}